<template>
  <div class="atlas-path">
    <span v-for="(item, index) in data" :key="index">
      <span class="atlas-path-node">{{item.node || item.name}}</span>
      <span>
        <img v-if="item.edge" class="atlas-path-line" src="../../assets/img/atlas-line.svg" alt="">
        <span class="atlas-path-edge" :class="{'has-edge' : item.edge}" >{{item.edge}}</span>
        <img v-if="item.edge" class="atlas-path-arrow" src="../../assets/img/atlas-arrow.svg" alt="">
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.atlas-path {
  padding: 8px 0 10px;
  .atlas-path-node {
    color: #464d6c;
    font-size: 14px;
  }
  .atlas-path-line {
    margin: 0 0 4px 9px;
  }
  .atlas-path-edge {
    color: #747990;
    font-size: 12px;
  }
  .has-edge {
    margin: 0 4px 0 4px;
  }
  .atlas-path-arrow {
    margin-right: 14px;
  }
}
</style>
